import gql from 'graphql-tag'

const productGroupsGetQueryQuery = gql`
  query productGroupsGet($offset: Int, $limit: Int, $criteria: Object, $sorting: Object) {
    productGroupsGet(input: { limit: $limit, offset: $offset, criteria: $criteria, sort: $sorting, nested: false })
      @rest(type: "productGroupsGetQuery", method: "POST", path: "product-group/list") {
      results
    }
  }
`

export default productGroupsGetQueryQuery
